import { Box, Button, Container, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { PATH_PAGE } from '../../routes/paths';
import Image from '../../components/Image';

const SUBDATA = [
  {
    icon: '/assets/Icones/stabilite_politique.png',
    title: 'Stabilité politique et économique',
    desc: 'Le Togo a connu une relative stabilité politique et économiques ces dernières années.',
  },
  {
    icon: '/assets/Icones/centre_fianice_region.png',
    title: 'Centre financier régional',
    desc: "Le Togo a le privilège d'un Hub de nombreuses institutions financières ayant leur siège a Lomé (Banque Ouest-Africaine de Développement Ecobank).",
  },
  {
    icon: '/assets/Icones/programme_educ.png',
    title: 'Programme éducatif de qualité',
    desc: 'Le Togo a un programme éducatif de qualité qui vise à fournir une éducation de base solide aux élèves.',
  },
];

export default function HomePourquoiLeTogo() {
  return (
    <Stack width={1} bgcolor="primary.main" alignItems="center" justifyContent="center" spacing={10} py={10}>
      <Typography variant="h1" color="common.white">
        Pourquoi Investir au Togo
      </Typography>
      <Container>
        <Grid container spacing={10}>
          {SUBDATA.map((card) => (
            <Grid item xs={12} md={4} key={card.title}>
              <CardLine icon={card.icon} title={card.title} desc={card.desc} />
            </Grid>
          ))}
        </Grid>
        <Stack width={1} alignItems="center" pt={7}>
          <Button
            component={Link}
            to={PATH_PAGE.pourquoi_le_togo.le_togo_en_bref}
            variant="contained"
            color="warning"
            sx={{ color: 'white', fontSize: 20, borderRadius: 5 }}
          >
            Pourquoi le Togo
          </Button>
        </Stack>
      </Container>
    </Stack>
  );
}

const CardLine = ({ icon, title, desc }) => (
  <Stack alignItems="center" spacing={1}>
    <Box border="2px solid white" borderRadius={25} p={0}>
      <Image src={icon} sx={{ height: 150, width: 150 }} />
    </Box>

    <Typography variant="h3" color="warning.main" textAlign="center">
      {title}
    </Typography>

    <Typography pt={3} variant="body2" color="common.white" textAlign="justify">
      {desc}
      <Link
        to={PATH_PAGE.pourquoi_le_togo.le_togo_en_bref}
        style={{ fontWeight: 'bold', paddingLeft: 5, textDecoration: 'none', color: 'white' }}
      >
        En savoir plus
      </Link>
    </Typography>
  </Stack>
);
